import SelectAutocomplete from "common/SelectAutocomplete";
import { SelectWrapper } from "common/BqnSelector";
import React, { useContext, useEffect } from "react";
import BqnContext from "common/BqnContext";
import styled from "styled-components";

export const bqnInstanceAsOption = ({ bqnId, hostname, offline = false }) => ({
  value: Number(bqnId),
  label: `BQN ${bqnId}` + (!hostname ? "" : `: ${hostname}`),
  offline,
});

const TitleAndSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0px 35px 0px;
`;

const SelectTitle = styled.div`
  margin-right: 20px;
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
`;

const doesNothing = () => {};

const optionOfValue = selected =>
  ({ value }) => String(value) === String(selected);

// A BQN that is not listed yet names itself, so that the input is not empty
// while the BQNs of the cluster are not known.
const optionOfBqnNotListed = (bqnId) =>
  bqnId === undefined ? null : bqnInstanceAsOption({ bqnId });

export const getSelectedBqn = (bqnId, loginBqnId) =>
  (bqnId !== "all") ? bqnId : loginBqnId;

const ChooseInstance = ({
  action = "shutdown",
  title = "Select BQN",
  selected,
  setSelected = doesNothing,
  includeAll = false,
}) => {
  const { bqns, loginBqnId, loadHostnames } = useContext(BqnContext);
  const options = [
    ...(includeAll === true ? [{ value: "all", label: "All" }] : []),
    ...(bqns !== undefined ? bqns.map(bqnInstanceAsOption) : []),
  ];

  // The names of the BQNs are asked for when the list is opened, and not
  // before: only the BQN selected is named in the input meanwhile, and a BQN
  // listed as online but disconnected does not answer for its name.
  const loadOptions = () => loadHostnames().catch(console.error);

  const selectedOption = options.find(optionOfValue(selected)) ??
    options.find(optionOfValue(loginBqnId)) ??
    optionOfBqnNotListed(selected ?? loginBqnId);

  // A BQN offline cannot answer, not even the one selected in the header.
  useEffect(() => {
    if (selectedOption?.offline === true) {
      setSelected(loginBqnId);
    }
  }, [selectedOption?.value, selectedOption?.offline]);
  return (
    <TitleAndSelectWrapper>
      <SelectTitle>{title}</SelectTitle>
      <SelectWrapper>
        <SelectAutocomplete
          className={`${action}-select`}
          title={`${action}-select`}
          name={action}
          selected={selectedOption}
          onOpen={loadOptions}
          onChange={(value) => {
            setSelected(value);
          }}
          options={options}
          // The options are built again on every render: compare their values.
          isOptionEqualToValue={(option, value) =>
            String(option.value) === String(value?.value ?? value)
          }
          getOptionDisabled={(option) => option.offline}
        />
      </SelectWrapper>
    </TitleAndSelectWrapper>
  );
};

export default ChooseInstance;
